import styled from 'styled-components'
import { media, colors } from 'styles'
import Button from 'components/Button/StyledButton'

const StyledNotificationsPanelItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem 0.5rem;

  & ~ & {
    border-top: 0.1rem solid ${colors.divider};
  }

  .body {
    display: flex;
    flex: 4;
  }

  .avatar {
    margin-right: 0.5rem;
    &-img {
      border-radius: 0.5rem;
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    box-sizing: border-box;
    font-weight: 400;
    color: ${colors.textMain};

    .text {
      margin: 0;
      font-size: 1.2rem;
    }

    .timestamp {
      margin: 0;
    }
    a {
      color: inherit;
    }
  }

  .username {
    text-decoration: none;
    font-weight: 600;
  }

  .timestamp {
    color: ${colors.textSecondary};
  }

  .action {
    flex: 2;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    ${Button} {
      padding: 0.4rem 0.6rem;
      color: ${colors.highlight};
      font-weight: 700;
      text-align: center; /* for links */
      background-color: transparent;
      border: 0.1rem solid ${colors.highlight};
    }
  }

  &:hover ${Button} {
    background-color: ${colors.highlight};
    color: ${colors.mainInverted};
  }

  ${media.mobile`
    .avatar {
      margin-right: 1rem;

      &-img {
        width: 6.5rem;
        height: 6.5rem;
      }
    }

    .body {
      flex: 5;
    }

    .info .text-row {
      font-size: 1.6rem;
    }

    .timestamp {
      font-size: 1.4rem;
    }

    .action {
      flex: 2;
    }

    .action ${Button} {
      display: block;
      padding: 1.2rem 1rem;
      font-size: 1.4rem;
    }
  `}

  @media (max-width: 48rem) {
    .avatar {
      margin-right: 1rem;

      &-img {
        width: 5rem;
        height: 5rem;
      }
    }
    .info .text-row {
      font-size: 1.4rem;
      max-height: 6rem;
    }

    .info .timestamp {
      font-size: 1.3rem;
    }

    .action ${Button} {
      font-size: 1.2rem;
    }
  }
`

export default StyledNotificationsPanelItem
